<span>{{params.displayName}}</span>
<i *ngIf="params?.tooltip" [matTooltip]="params?.tooltip"class="mr-0 ml-2 fs-18 material-icons" aria-hidden="true">info</i>